export default function ProgressBar({ progressMessage, progressStage }) {
  const stageCount = 5;

  return (
    <div style={{ width: "100%", maxWidth: 500, margin: "20px auto" }}>
      <div className='text' style={{ marginBottom: 8, fontWeight: "bold", fontSize: 16 }}>
        {progressMessage || "Waiting..."}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {(() => {
          const bars = [];
          for (let i = 0; i < stageCount; i++) {
            const isActive = i < progressStage;
            bars.push(
              <div
                key={i}
                style={{
                  flex: 1,
                  height: 20,
                  marginRight: i < stageCount - 1 ? 4 : 0,
                  backgroundColor: isActive ? "#422800" : "#e0e0e0",
                  borderRadius: 4,
                  textAlign: "center",
                  lineHeight: "20px",
                  color: isActive ? "white" : "#555",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              />
            );
          }
          return bars;
        })()}
      </div>
    </div>
  );
}
